<div id = "d3charts">
    </div>

<style>
.activesegment {
    fill: black !important;
}
</style>